"use client";

import { motion } from "framer-motion";
import UPCOMING_EVENTS from "../data/upcoming-events.json";
import NEWS from "../data/news.json";

const EventCard = ({ title, date, description, status, link }) => (
	<div className="bg-white p-6 sm:p-8 rounded-lg shadow-lg flex flex-col justify-between h-full">
		<div>
			<div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 mb-4">
				<h3 className="text-lg sm:text-xl font-bold text-[#1666ba] leading-snug">{title}</h3>
				<span className="self-start px-3 py-1 rounded-full text-sm text-white bg-[#819f3d] whitespace-nowrap flex-shrink-0">
					{status}
				</span>
			</div>
			<p className="text-gray-600 mb-4 text-sm sm:text-base">{description}</p>
			<div className="flex items-center text-gray-500 mb-4 text-sm sm:text-base">
				<svg className="w-5 h-5 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
					<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
						d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
				</svg>
				<span>{date}</span>
			</div>
		</div>

		{link && status === "Upcoming" && (
			<a
				href={link}
				target="_blank"
				rel="noopener noreferrer"
				className="inline-block w-full sm:w-auto text-center bg-[#1666ba] text-white px-4 py-3 rounded-full text-sm hover:bg-blue-700 transition-colors font-medium mt-2">
				Register Now →
			</a>
		)}
	</div>
);

const SectionHeading = ({ children }) => (
	<h2 className="text-2xl sm:text-3xl font-bold text-[#1666ba] mb-8 text-center">
		{children}
	</h2>
);

const NewsCard = ({ title, description, date }) => (
	<div className="bg-white p-6 sm:p-8 rounded-lg shadow-lg mb-6">
		<div className="border-l-4 border-[#1666ba] pl-4">
			<h3 className="text-lg sm:text-xl font-bold text-[#1666ba] mb-2">{title}</h3>
			<p className="text-gray-600 mb-4 text-sm sm:text-base">{description}</p>
			<div className="flex items-center text-gray-500 text-sm sm:text-base">
				<svg className="w-5 h-5 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
					<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
						d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
				</svg>
				<span>{date}</span>
			</div>
		</div>
	</div>
);

const Events = () => {
	return (
		<div className="bg-white pt-20">
			{/* Hero */}
			<section className="relative py-16 sm:py-20 bg-[#819f3d] text-white">
				<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
					<motion.h1
						initial={{ y: -20, opacity: 0 }}
						animate={{ y: 0, opacity: 1 }}
						transition={{ duration: 0.8 }}
						className="text-3xl sm:text-4xl md:text-5xl font-bold text-center mb-4">
						Stay Updated with the Latest
					</motion.h1>
				</div>
			</section>

			{/* Upcoming Events */}
			<section className="py-12 sm:py-16">
				<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
					<motion.div
						initial={{ opacity: 0, y: 20 }}
						whileInView={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.8 }}>
						<SectionHeading>Upcoming Events</SectionHeading>
						<div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
							{UPCOMING_EVENTS.map((event, idx) => (
								<EventCard key={idx} {...event} />
							))}
						</div>
					</motion.div>
				</div>
			</section>

			{/* News & Achievements */}
			<section className="py-12 sm:py-16 bg-gray-50">
				<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
					<motion.div
						initial={{ opacity: 0, y: 20 }}
						whileInView={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.8 }}>
						<SectionHeading>News and Achievements</SectionHeading>
						{NEWS.map((item, idx) => (
							<NewsCard key={idx} {...item} />
						))}
					</motion.div>
				</div>
			</section>
		</div>
	);
};

export default Events;
